export enum PaymentEnum {
  Mensuel = 'Mensuel',
  Trimestriel = 'Trimestriel',
  Annuel = 'Annuel'
}
